import { call } from 'redux-saga/effects'

import { DRAWING_TYPES } from '../../../shared/constants/drawable-types'
import { Workspace } from '../../lib/toolBoxes/2D'

/**
 * Retrieves all joist lines (SECTION type items) for a specific opening group
 * @param workspaceTool - The workspace tool instance
 * @param openingGroupId - The ID of the opening group to filter by
 * @returns Array of paper.Item representing joist lines
 */
export function* getJoistLinesByGroupId(workspaceTool: Workspace | any, openingGroupId: number | string) {
    const joistLines: paper.Item[] = yield call(workspaceTool.getItemsWithCriteria, 'data', (data: any) => {
        return data.opening_group_id === openingGroupId && data.shapeType === DRAWING_TYPES.SECTION
    })

    return joistLines
}
